import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import Icon from "./Icon";
import tcbase from "../shim/tcbase";

export const ProductPromo = ({ center, children }) => (
  <div className={`product-promo ${center && "product-promo--centered"}`}>
    {children}
  </div>
);

export const ProductPromoContentPiece = ({ width = 50, children }) => (
  <div
    className="product-promo__content-piece"
    style={{ flexBasis: `${width}%`, minWidth: `${width}%` }}
  >
    {children}
  </div>
);

export const ProductPromoFeatures = ({ columns = 2, children }) => (
  <div
    className="product-promo__features"
    style={{
      gridTemplateColumns: `repeat(${columns}, 1fr)`
    }}
  >
    {children}
  </div>
);

export const ProductPromoFeatureItem = ({
  icon,
  fullWidth = false,
  borderColor,
  children
}) => (
  <div
    className="product-promo__feature-item"
    style={{
      gridColumn: fullWidth && "1 / -1",
      borderColor
    }}
  >
    {icon && <Icon name={icon} />}
    {children}
  </div>
);

export const ProductPromoImage = ({ fileName, dropShadow }) => {
  const { urls: { static: staticFolder } = {} } = tcbase || {};
  const imagePath = `${staticFolder}images/${fileName}`;

  return (
    <>
      <img
        src={imagePath}
        className={clsx(
          "product-promo__image",
          dropShadow && "product-promo__image--dropshadow"
        )}
      />
    </>
  );
};

export const ProductPromoTitleLabel = ({ text }) => (
  <h3 className="product-promo__title-label">{text}</h3>
);

export const ProductPromoTitle = ({ text }) => (
  <h2 className="product-promo__title">{text}</h2>
);

ProductPromoTitleLabel.propTypes = {
  text: PropTypes.string
};

ProductPromoTitle.propTypes = {
  text: PropTypes.string
};

ProductPromo.propTypes = {
  center: PropTypes.bool,
  children: PropTypes.node
};

ProductPromoContentPiece.propTypes = {
  width: PropTypes.number,
  children: PropTypes.node
};

ProductPromoFeatures.propTypes = {
  columns: PropTypes.number,
  children: PropTypes.node
};

ProductPromoFeatureItem.propTypes = {
  icon: PropTypes.string,
  fullWidth: PropTypes.bool,
  borderColor: PropTypes.string,
  children: PropTypes.node
};

ProductPromoImage.propTypes = {
  fileName: PropTypes.string,
  dropShadow: PropTypes.bool
};
